export default "__VITE_ASSET__37168262__"